// extracted by mini-css-extract-plugin
export default {"link-button":"LinkItem_link-button__P-Q4Y","link-item":"LinkItem_link-item__+WUZF","link-item-name":"LinkItem_link-item-name__kSR5A"};